<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="mb-2">Inserire le motivazioni per la modifica</p>
  <textarea class="form-control" rows="5" [formControl]="motivazione" aria-label="Motivazione"></textarea>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Annulla</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">Conferma</button>
</div>